import React from 'react';
import Grid from '@material-ui/core/Grid';
import AsyncSelectControl from '../../Components/AsyncSelectControl';
import ProcessElementDialogHelper from '../../Util/ProcessElementDialogs';

// const ParticipationTypes = [
//   { value: "Any", label: "Any role member" },
//   { value: "All", label: "All role members"},
//   { value: "Majority", label: "Majority of role members"},
// ];

// BlockReEntryOn controls whether this approval refuses to be re-created for
// an item that has already resolved here once. Decline-loops and other
// workflow rerouting bypass the block — only external re-entry (a new trigger
// event from outside the workflow, like a document mutation) is blocked.
const BlockReEntryTypes = [
  { value: "", label: "Never (default)" },
  { value: "approved", label: "After Approved" },
  { value: "any", label: "After any decision (Approved or Declined)" },
];

export default function GetContent(location, history, organizationId, projectId, processElement, processElementConnections_Input,
  onGetLocalState, onSetLocalState, onGetLocalProperty, onSetLocalProperty,
  onApiError, onAlert, onGetListValuesAndLabelsPropertyName, onChangeHandlers,
  onSelectionListValueChange, onSelectionListCreateOption) {

  if (!processElement) {
    return null;
  }

  const dh = new ProcessElementDialogHelper(location, history, organizationId, projectId, processElement, processElementConnections_Input,
      onGetLocalState, onSetLocalState, onGetLocalProperty, onSetLocalProperty,
      onApiError, onAlert, onGetListValuesAndLabelsPropertyName, onChangeHandlers,
      onSelectionListValueChange, onSelectionListCreateOption);

  // Get list value property for required fields
  const listValueId_RequiredFieldIDForApprove = onGetListValuesAndLabelsPropertyName("RequiredFieldIDForApprove", true);

  let handleGetBlockReEntryListValuesPromise = filter => {
    // Initial loading will not have the name/label. Set it here.
    let listValueId = [onGetListValuesAndLabelsPropertyName("BlockReEntryOn", false)];
    if (processElement[listValueId] && processElement[listValueId].value) {
      if (!processElement[listValueId].label) {
        const matchingType = BlockReEntryTypes.find(p => p.value === processElement[listValueId].value);
        if (matchingType) {
          processElement[listValueId].label = matchingType.label;
        }
      }
    } else {
      // Default value: Never
      onSelectionListValueChange("BlockReEntryOn", false)(BlockReEntryTypes.filter(p => p.value === "")[0]);
    }
    return Promise.resolve(BlockReEntryTypes);
  };

  return (
    <Grid container direction="column" spacing={2}>
      <Grid item>
        {dh.GetActionContentForEmailAddressControlAndPreferredItemType("AssignmentUserEmail", "Assigned to",
          false, true, true, true, true, true)}
      </Grid>
      <Grid item>
        <AsyncSelectControl label="Required fields for approve"
          placeholder="Select optional..."
          isMulti
          onGetOptionsFilterPromise={dh.handleGetFieldListValuesPromise}
          listValues={processElement[listValueId_RequiredFieldIDForApprove]}
          onValueChange={onSelectionListValueChange("RequiredFieldIDForApprove", true)}
          helperText="Users will only be able to approve if all specified fields have values."
        />
      </Grid>
      <Grid item>
        <AsyncSelectControl label="Block re-entry on"
          notClearable
          onGetOptionsFilterPromise={handleGetBlockReEntryListValuesPromise}
          listValues={processElement[onGetListValuesAndLabelsPropertyName("BlockReEntryOn", false)]}
          onValueChange={onSelectionListValueChange("BlockReEntryOn", false)}
          helperText="Refuse to re-create this approval if the item has already resolved here. Workflow decline/approve loops still produce new approvals — only external triggers (form submissions, document mutations) are blocked."
        />
      </Grid>
    </Grid>
  );
}
